import { render, staticRenderFns } from "./IkasOrderStatus.vue?vue&type=template&id=dd625778"
import script from "./IkasOrderStatus.vue?vue&type=script&lang=js"
export * from "./IkasOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./IkasOrderStatus.vue?vue&type=style&index=0&id=dd625778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports